import { useState, useEffect } from "react";
import { useAuth } from "./useAuth";
import { useFlags } from "launchdarkly-react-client-sdk";

const useUshopRedirectMarkets = () => {
  // @ts-expect-error untyped auth value
  const { userInfo } = useAuth();
  const flags = useFlags();
  const [shopLink, setShopLink] = useState("");

  useEffect(() => {
    if (!flags?.referralLinkConfig || !userInfo) return;
    const loggedUserCountry = userInfo.countryCode;
    const referralLinkConfig = flags?.referralLinkConfig;
    // 1 = Cosminc, 2 = uShop, 3 = Drupal
    const countryConfig = referralLinkConfig[loggedUserCountry.toLowerCase()];

    switch (countryConfig) {
      case 1:
        setShopLink(
          `${process.env.REACT_APP_SHOP2_URL}/sl/${btoa(userInfo.token)}`
        );
        break;
      case 2: {
        const ushopBase =
          process.env.REACT_APP_IS_PRODUCTION === "false"
            ? process.env.REACT_APP_UNICITY_SHOP_URL_UAT
            : process.env.REACT_APP_UNICITY_SHOP_URL_PROD;
        setShopLink(
          `${ushopBase}/${userInfo.countryCode.toLowerCase()}`
        );
        break;
      }
      default:
        setShopLink(
          `${process.env.REACT_APP_SHOP_URL}/${btoa(userInfo.token)}`
        );
        break;
    }
  }, [flags, userInfo]);

  return { shopLink };
};

export { useUshopRedirectMarkets };
